import * as React from "react";
import { useCookies } from "react-cookie";
import API from "./api/handler";
//import { startOpenReplay, identifyUser } from "./openreplay";

// Lightweight Capacitor Preferences helpers with safe fallback
async function prefGet(key) {
  try {
    const { Preferences } = await import("@capacitor/preferences");
    const { value } = await Preferences.get({ key });
    return value ?? null;
  } catch {
    return null;
  }
}

async function prefSet(key, value) {
  try {
    const { Preferences } = await import("@capacitor/preferences");
    await Preferences.set({ key, value });
  } catch {
    // ignore on web if plugin not available
  }
}

async function prefRemove(key) {
  try {
    const { Preferences } = await import("@capacitor/preferences");
    await Preferences.remove({ key });
  } catch {
    // ignore on web if plugin not available
  }
}

const AuthContext = React.createContext();

export function useAuth() {
  const [cookies, setCookie, removeCookie] = useCookies([
    "oauth_token",
    "oauth_secret",
  ]);

  const initialUserId = typeof window !== "undefined" ? localStorage.getItem("user_id") : null;
  const initialAuthed = Boolean((cookies["oauth_token"] && cookies["oauth_secret"]) || initialUserId);
  const [authed, setAuthed] = React.useState(initialAuthed);
  const [userId, setUserId] = React.useState(initialUserId);

  // Load persisted user_id on mount 
  React.useEffect(() => {
    let mounted = true;
    (async () => {
      const prefId = await prefGet("user_id");
      const lsId = typeof window !== "undefined" ? localStorage.getItem("user_id") : null;
      const id = prefId || lsId;
      if (!mounted) return;
      if (id) setUserId(String(id));
  const hasCookies = Boolean(cookies["oauth_token"] && cookies["oauth_secret"]);
  setAuthed(Boolean(hasCookies || id));
    })();
    return () => { mounted = false; };
  }, [cookies["oauth_token"], cookies["oauth_secret"]]);

  // When auth state or userId changes, update OpenReplay identification
  React.useEffect(() => {
    if (authed && userId) {
      // identifyUser(userId);
    }
  }, [authed, userId]);

  return {
    authed,
    login(email, pass) {
      return new Promise(async (res, rej) => {
        let login_res = await API.Login.login(email, pass);
        
        if (
          login_res.status_code === 200 &&
          login_res.body.oauth_secret &&
          login_res.body.oauth_token
        ) {
          setCookie("oauth_token", login_res.body.oauth_token);
          setCookie("oauth_secret", login_res.body.oauth_secret);
          // Also persist tokens to Preferences for native
          await prefSet("oauth_token", login_res.body.oauth_token);
          await prefSet("oauth_secret", login_res.body.oauth_secret);
          const idStr = String(login_res.body.user.user_id);
          localStorage.setItem("user_id", idStr);
          await prefSet("user_id", idStr);
          setUserId(idStr);
          setAuthed(true);
          // Proactively update OpenReplay immediately upon login
          try {
            identifyUser(idStr);
          } catch {}
          res(true);
        } else {
          
          setAuthed(false);
          rej(login_res.error_code);
        }
      });
    },
    logout() {
      return new Promise((res) => {
  removeCookie("oauth_token");
  removeCookie("oauth_secret");
        localStorage.removeItem("user_id");
  prefRemove("user_id");
  prefRemove("oauth_token");
  prefRemove("oauth_secret");
        setAuthed(false);
        setUserId(null);
        res();
      });
    },
    userId,
  };
}

export function AuthProvider({ children }) {
  const auth = useAuth();

  React.useEffect(() => {
    // Start OpenReplay in production 
    // if (process.env.NODE_ENV === "production") {
    //   startOpenReplay();
    // }
  }, []);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export default function AuthConsumer() {
  return React.useContext(AuthContext);
}